var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 85,
    viewBox: "0 0 68 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9999 0.833252C15.6208 0.833252 0.666599 15.7874 0.666599 34.1458C0.545766 60.9999 32.7333 83.2666 33.9999 84.1666C33.9999 84.1666 67.4541 60.9999 67.3333 34.1666C67.3333 15.7874 52.3791 0.833252 33.9999 0.833252ZM33.9999 50.8333C24.7916 50.8333 17.3333 43.3749 17.3333 34.1666C17.3333 24.9583 24.7916 17.4999 33.9999 17.4999C43.2083 17.4999 50.6666 24.9583 50.6666 34.1666C50.6666 43.3749 43.2083 50.8333 33.9999 50.8333Z",
    fill: "#292321"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPoint);
export default __webpack_public_path__ + "static/media/map_point.d1c73c90848f09ad705c6d8900578283.svg";
export { ForwardRef as ReactComponent };